// extracted by mini-css-extract-plugin
export default {"form-control":"input_form-control__1q1Sf","label":"input_label__Ga2T1","input":"input_input__mBKb2"};